import  React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import LogoBar from '../partials/logo-bar'

class NotFound extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <>
                <LogoBar />
                <main id="404" className="not-found">
                    <div className="container">
                        <h1>Oops...</h1>
                    </div>
                </main>
            </>
        )
    }
}

export default withRouter(NotFound)